var __jsx = React.createElement;
import * as React from 'react';
import { RichText } from '@bob/rich-text';
import * as ds from '@bob/design-system';
import { styles as S } from '@bob/design-system';
import styled from 'styled-components';
export function Description(_ref) {
  var _brand$description;

  var brand = _ref.brand;
  var hasAnyNetwork = brand.socialNetwork.facebook || brand.socialNetwork.instagram || brand.socialNetwork.twitter || brand.socialNetwork.linkedin;
  return __jsx(Section, null, (brand.video || brand.description) && __jsx(S.heading.Title3, {
    as: "h2"
  }, "La marque"), brand.video && __jsx(ds.MediaLoader, {
    url: brand.video.url,
    placeholder: __jsx(ds.BlobPicture, {
      variant: 5,
      color: "light-green",
      src: brand.video.preview.src,
      size: 330
    })
  }), brand.claim && __jsx(Claim, null, brand.claim), __jsx(RichText, {
    document: (_brand$description = brand.description) === null || _brand$description === void 0 ? void 0 : _brand$description.json
  }), hasAnyNetwork && __jsx(Sharing, null, __jsx(S.copy.Text2, null, "Retrouvez-les sur les r\xE9seaux"), __jsx(Networks, null, brand.socialNetwork.facebook && __jsx("a", {
    href: brand.socialNetwork.facebook,
    rel: "noopener noreferrer",
    target: "_blank"
  }, __jsx(ds.icons.Facebook, {
    size: 24
  })), brand.socialNetwork.instagram && __jsx("a", {
    href: brand.socialNetwork.instagram,
    rel: "noopener noreferrer",
    target: "_blank"
  }, __jsx(ds.icons.Instagram, {
    size: 24
  })), brand.socialNetwork.twitter && __jsx("a", {
    href: brand.socialNetwork.twitter,
    rel: "noopener noreferrer",
    target: "_blank"
  }, __jsx(ds.icons.Twitter, {
    size: 24
  })), brand.socialNetwork.linkedin && __jsx("a", {
    href: brand.socialNetwork.linkedin,
    rel: "noopener noreferrer",
    target: "_blank"
  }, __jsx(ds.icons.LinkedIn, {
    size: 24
  })))));
}
var Sharing = styled.div.withConfig({
  displayName: "Description__Sharing",
  componentId: "sc-1gghx70-0"
})(["display:flex;flex-direction:column;align-items:center;margin:40px 0 80px;", "{margin-bottom:20px;}"], S.copy.Text2);
var Networks = styled.div.withConfig({
  displayName: "Description__Networks",
  componentId: "sc-1gghx70-1"
})(["display:flex;", "{margin:0 15px;}"], ds.icons.Icon);
var Claim = styled(S.wysiwyg.Claim).withConfig({
  displayName: "Description__Claim",
  componentId: "sc-1gghx70-2"
})([""]);
var Section = styled.section.withConfig({
  displayName: "Description__Section",
  componentId: "sc-1gghx70-3"
})(["", "{margin-bottom:35px;}", "{margin:37px auto 66px;", "{", "{@media not screen and (", "){width:280px;height:280px;}}}}"], S.heading.Title3, ds.MediaLoader, ds.BlobPicture, S.picture.Picture, ds.breakpoint.MOBILE_M);